if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');
      }

      get variantIdSelect() {
        return this.querySelector('[name="id"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        this.select = this.querySelector('select');

        this.init();
        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.variantIdSelect.value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      disconnectedCallback() {
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.observer) this.observer.disconnect();
        if (this.viewport && this.onViewportChange) {
          this.viewport.removeEventListener('resize', this.onViewportChange);
          this.viewport.removeEventListener('scroll', this.onViewportChange);
          window.removeEventListener('scroll', this.onViewportChange);
        }
        if (this.probe && this.probe.parentNode) this.probe.parentNode.removeChild(this.probe);
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        /* Høyden ble tidligere bare målt ved innlasting og ved bytte mellom
           mobil og desktop. På iOS endrer viewporten seg også når verktøylinja
           i Safari trekker seg sammen, og da ble --sticky-atc-bar-height
           stående på en foreldet verdi. Den styrer bunnpolstringen på body og
           plasseringen av tilbake-til-toppen-knappen. */
        this.onResize = FoxTheme.utils.debounce(this.checkDevice.bind(this), 100);
        window.addEventListener('resize', this.onResize);

        this.syncViewportOffset();

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.container.classList.toggle('sticky-atc-bar--show', !entry.isIntersecting);
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);
        this.syncWithMainProductForm();
      }

      /* Baren ble hengende i lufta med et mellomrom under seg, der siden bak
         lyste gjennom. Årsaken er at bottom: 0 ikke lander på den fysiske
         skjermkanten på iOS.

         Målingen skjer mot et usynlig 1px-element som selv er fixed med
         bottom: 0. Det viser hvor bottom: 0 FAKTISK havner i denne
         nettleseren, og differansen opp til der visualViewport slutter er
         nøyaktig mellomrommet under baren.

         Dette erstatter en tidligere variant som brukte window.innerHeight
         som referanse. Den virket i Safari, men ga null i Chrome på iOS,
         fordi innerHeight der utelater det samme området som bottom: 0 gjør
         — differansen ble null og baren flyttet seg ikke. Et ekte fixed
         element måler det som faktisk skjer, uansett nettleser.

         Bare positiv differanse brukes. Negativ betyr at layout-viewporten
         stikker under den synlige flata (typisk mens tastaturet er oppe) —
         da skal baren bli stående, ikke flyttes opp. Uten visualViewport
         (eldre nettlesere) blir offseten 0 og oppførselen som før. */
      syncViewportOffset() {
        const vv = window.visualViewport;
        if (!vv) return;

        /* display må tvinges. Temaet har en regel som skjuler tomme elementer,
           og en sonde med display: none måler 0 og ville dyttet baren helt ut
           av skjermen. */
        const probe = document.createElement('div');
        probe.setAttribute('aria-hidden', 'true');
        probe.style.cssText =
          'position:fixed;bottom:0;left:0;width:1px;height:1px;pointer-events:none;opacity:0;';
        probe.style.setProperty('display', 'block', 'important');
        document.body.appendChild(probe);
        this.probe = probe;

        this.onViewportChange = () => {
          const rect = probe.getBoundingClientRect();
          /* Måler sonden 0, er den ikke rendret, og da er differansen
             meningsløs. Uten denne sperren ble offseten hele viewporthøyden
             og baren forsvant ut av skjermen. Taket på 120px er samme sikring
             mot en måling som løper løpsk. */
          const gap = rect.height === 0 ? 0 : Math.round(vv.height + vv.offsetTop - rect.bottom);
          const safe = Math.min(Math.max(gap, 0), 120);
          document.documentElement.style.setProperty('--sticky-atc-bar-offset', safe + 'px');
        };

        this.viewport = vv;
        this.onViewportChange();
        vv.addEventListener('resize', this.onViewportChange);
        vv.addEventListener('scroll', this.onViewportChange);
        window.addEventListener('scroll', this.onViewportChange, { passive: true });
      }

      /* Mål wrapperen (.sticky-atc-bar), ikke <sticky-atc-bar> inni den. Det er
         wrapperen som er position: fixed, og det er dens høyde body skal
         polstres med. */
      checkDevice() {
        const height = this.container ? this.container.offsetHeight : this.clientHeight;
        document.documentElement.style.setProperty('--sticky-atc-bar-height', height + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = `<s>${FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat)}</s>`)
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
